
import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator'
import { MobileOffer, HomeOffer, NamedOfferCategoryType } from '@alao-frontend/core'
import OfferDealPrices from '~/components/DealOfTheDay/OfferDeal/OfferDealPrices.vue'
import { AlButton } from '~/components/ui'
import { getExternalCompareMobileSlugHref, getExternalCompareHomeSlugHref } from '~/utils/external-links.utils'

@Component({
  components: { AlButton, OfferDealPrices },
})
export default class OfferDeal extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
    required: true,
  })
  offer!: MobileOffer | HomeOffer

  @Prop({
    type: String,
    default: '',
  })
  imageUrl!: string

  get url () {
    if (!this.offer) {
      return ''
    }

    // Формируем внешнюю ссылку в зависимости от типа предложения
    if (this.offer.constructor.name === 'MobileOffer') {
      return getExternalCompareMobileSlugHref(this.$config.BASE_URL, this.localePath, this.offer.slug)
    } else {
      return getExternalCompareHomeSlugHref(this.$config.BASE_URL, this.localePath, this.offer.slug)
    }
  }

  @Emit('cta:click')
  onCTAClick () {
    return true
  }
}
